import { ThemeSwitcher as SharedThemeSwitcher } from "@guardian/shared-ui";
import { useTranslation } from "react-i18next";

export function ThemeSwitcher() {
  const { t } = useTranslation();

  return (
    <SharedThemeSwitcher
      showSystemOption={false}
      labels={{
        toggle: t("nav.toogleTheme"),
        light: t("nav.lightTheme"),
        dark: t("nav.darkTheme"),
      }}
    />
  );
}
